import { useContext } from "react";
import { useApiCall } from "../custom-hooks/api-call"
import { GlobalContext } from "../../context/Context";

export const useCheckTime = () => {
    let {dispatch} = useContext(GlobalContext);
    const apiCall = useApiCall();

    const call = async() => {
        try {
            let apiRes = await apiCall({ url: 'check-user-time', method: 'get'});
            if(apiRes?.timeInEnabled == "yes"){
                dispatch({ type: 'TIME_OUT', payload: apiRes?.time_activity, hours: apiRes?.hrs });
            }else{
                dispatch({ type: 'TIME_IN', payload: apiRes?.time_activity });
            }
            return apiRes
        } catch (error) {
            throw error;
        }
    }

    return call;
}